// 封装axios
import React from 'react'
import axios from 'axios'
import { message } from 'antd';
import { cloneDeep, isEmpty } from 'lodash';

// const devBaseUrl = 'http://172.16.3.204:9020'  //开发环境
const devBaseUrl = 'https://sa.giraffar.com/api/'  //开发环境
// const devBaseUrl = 'http://124.222.138.92:9020'  //测试服务器
// const proBaseUrl = 'http://124.222.138.92:9020'  //测试服务器
const proBaseUrl = window.location.origin + '/api/'  //生产环境

const BASE_URL = process.env.NODE_ENV === 'development' ? devBaseUrl : proBaseUrl   //  请求域名
const TIMEOUT = 50000   //请求时间(毫秒单位)
// process.env.NODE_ENV === 'development'   判断是否是开发环境

export { BASE_URL }




// 创建一个axios实例
const instance = axios.create({
    baseURL: BASE_URL, //请求域名
    timeout: TIMEOUT //请求超时时间 
})
//设置axios拦截器: 请求拦截器
instance.interceptors.request.use(config => {
    let headers = cloneDeep(config.headers);


    if (headers['Content-Type']) {
        // 自定义配置头部
        // headers.Authorization = process.env.NODE_ENV === 'development' ? localStorage.getItem('token') : sessionStorage.getItem('token')
        // headers.Authorization = sessionStorage.getItem('token')  //配置请求头token 

    } else {
        // 自动配置默认头部
        headers = {
            'Content-Type': 'application/json',
            // 'Authorization': process.env.NODE_ENV === 'development' ? localStorage.getItem('token') : sessionStorage.getItem('token')
        }

    }
    //得到请求方式和请求体数据
    const token = sessionStorage.getItem('token')
    if (token) {
        // config.headers.Authorization = token
        config.headers = {
            'subscribe-token': token
        }
    }
    return config;
}, err => {
    // 请求未成功发出，如：没有网络...
    return Promise.reject(err)
})


//设置axios拦截器: 响应拦截器
instance.interceptors.response.use(res => {
    message.config({
        top: '30vh',
    })
    // 成功响应的拦截
    const data = res.data;
    const code = data.code;

    // if (code == 1002) return data   //没有账号
    // if (code == 4001) return data  //提示登录失败
    if (code !== 200) return message.error(data.message)
    return data;
}, err => {
    //请求的地址错误 会进入这里
    // 也可以在这里处理请求状态嘛 ，比如503,404 err.response.status
    // try{
    //     throw new Error(`请求失败，状态码: ${err.response.status}`);
    //     // return Promise.reject(err);
    // }catch{}
    return Promise.reject(err);
})


export default instance
